import '../../style/base.css';
import '../../info/index.css';
import '../../icon/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/nav-bar/style/index.js
// module id = FO5P
// module chunks = 62